import SHAREBOX_I32_BREAKDWON_STEPS from './i32';

const SHAREBOX_S32_PLUS_BREAKDOWN_STEPS = SHAREBOX_I32_BREAKDWON_STEPS;

export default SHAREBOX_S32_PLUS_BREAKDOWN_STEPS;
